import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "./CartContext";
import Navbar from "./Navbar";
import "./home.css";
import { Badge, Button } from "react-bootstrap";
import Swal from "sweetalert2";

const CheckoutPage = () => {
  const { cart, clearCart, removeFromCart } = useCart();
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    date: "",
    time: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [bookedSlots, setBookedSlots] = useState([]);

  const scriptURLl =
    "https://script.google.com/macros/s/AKfycbwT4zbeGXl8IfKt9qGLnPGVjvAqME2EOEmODZPo2TLiHo1xsj_f8iqJ1G5rHhchpW-gjQ/exec"; // Paste the same URL here

  // Fetch real-time blocks from the sheet on load
  useEffect(() => {
    fetch(scriptURLl)
      .then((res) => res.json())
      .then((data) => {
        console.log("Blocked Slots:", data);
        if (Array.isArray(data)) {
          setBookedSlots(data);
        }
      })
      .catch((err) =>
        console.error("Error syncing active blocked slot structures:", err),
      );
  }, []);

  useEffect(() => {
  if (!window.Razorpay) {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }
}, []);

  const scriptURL =
    "https://script.google.com/macros/s/AKfycbwuiSSV27FQPWSlRpwJyudjwnXR3QoCcMys83nV4qj9LTUvG_K4myXR7Ce_laoxfgiE/exec";
  const cleanPrice = (price) => {
    if (typeof price === "number") return price;
    if (typeof price === "string") {
      const cleaned = price.replace(/[^\d.]/g, "");
      return parseFloat(cleaned) || 0;
    }
    return 0;
  };

  const totalAmount = cart.reduce((sum, item) => {
    const price = cleanPrice(item.price);
    const quantity = Number(item.quantity) || 1;
    return sum + price * quantity;
  }, 0);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    })
      .format(amount)
      .replace("₹", "");
  };

  useEffect(() => {
    if (cart.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Your cart is empty!",
        text: "Please add services before proceeding.",
        confirmButtonText: "Go to Home",
      }).then(() => navigate("/home"));
    }
  }, [cart, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const checkSlotAvailability = (date, time) => {
    const selectedMinutes =
      Number(time.split(":")[0]) * 60 + Number(time.split(":")[1]);

    return !bookedSlots.some((slot) => {
      if (slot.date !== date) return false;

      const start =
        Number(slot.startTime.split(":")[0]) * 60 +
        Number(slot.startTime.split(":")[1]);

      const end =
        Number(slot.endTime.split(":")[0]) * 60 +
        Number(slot.endTime.split(":")[1]);

      return selectedMinutes >= start && selectedMinutes < end;
    });
  };

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    setFormData({ ...formData, date: selectedDate });

    if (formData.time) {
      const isAvailable = checkSlotAvailability(selectedDate, formData.time);
      if (!isAvailable) {
        showSlotBookedAlert();
        setFormData({ ...formData, time: "" });
      }
    }
  };
  // 1. Get today's date string to prevent selecting past dates
  const todayStr = new Date().toISOString().split("T")[0];

  // 2. Check if the selected date has hit maximum bookings (e.g., 3 slots)
  const slotsForSelectedDate = bookedSlots.filter(
    (slot) => slot.date === formData.date,
  );
  const isDateFullyBooked = slotsForSelectedDate.length >= 3;

  const handleTimeChange = (e) => {
    const selectedTime = e.target.value;

    if (!checkSlotAvailability(formData.date, selectedTime)) {
      showSlotBookedAlert();

      setFormData((prev) => ({
        ...prev,
        time: "",
      }));

      return;
    }

    setFormData((prev) => ({
      ...prev,
      time: selectedTime,
    }));
  };

  const showSlotBookedAlert = () => {
    Swal.fire({
      title: "Slot Unavailable",
      html: `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 10px 0;">
        <div style="width: 72px; height: 72px; background: #fef2f2; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 16px; border: 4px solid #fee2e2;">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#ef4444" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="M4.285 12.433a.5.5 0 0 0 .683-.183A3.5 3.5 0 0 1 8 10.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.5 4.5 0 0 0 8 9.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5"/>
          </svg>
        </div>
        <p style="color: #4b5563; font-size: 0.95rem; line-height: 1.5; margin: 0; font-weight: 400;">
          This time slot is already fully booked. <br/>Please choose a different time or date.
        </p>
      </div>
    `,
      showConfirmButton: true,
      confirmButtonText: "Choose Another Time",
      buttonsStyling: false,
      customClass: {
        popup: "rounded-4 border-0 shadow-sm p-4",
        title: "fw-bold text-dark fs-4 pt-2",
        confirmButton:
          "btn btn-primary px-4 py-2.5 rounded-3 fw-semibold w-100 mt-2",
      },
    });
  };

  const validateForm = () => {
    const { name, number, email, date, time, message } = formData;
    if (!name || !number || !email || !date || !time || !message) {
      Swal.fire({
        icon: "error",
        title: "Missing Fields",
        text: "Please fill in all required fields.",
      });
      return false;
    }
    if (!/^\d{10}$/.test(number)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Phone Number",
        text: "Please enter a valid 10-digit phone number.",
      });
      return false;
    }
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address.",
      });
      return false;
    }
    return true;
  };

  const submitToGoogleScript = async (paymentMethod, paymentId = "") => {
    if (!validateForm()) return;
    if (!checkSlotAvailability(formData.date, formData.time)) {
      showSlotBookedAlert();
      return;
    }
    setLoading(true);

    const services = cart.map((item) => item.name).join(", ");
    const form = new FormData();
    form.append("name", formData.name);
    form.append("number", formData.number);
    form.append("email", formData.email);
    form.append("services", services);
    form.append("Date Time", `${formData.date} ${formData.time}`);
    form.append("location", formData.message);
    form.append("totalAmount", totalAmount);
    form.append("paymentMethod", paymentMethod);
    form.append("paymentId", paymentId);

    fetch(scriptURL, { method: "POST", body: form })
      .then(() => {
        Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        }).fire({ icon: "success", title: "Your order has been confirmed!" });

        setLoading(false);
        setFormData({
          name: "",
          number: "",
          email: "",
          date: "",
          time: "",
          message: "",
        });
        clearCart();
        navigate("/home");
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Something went wrong. Please try again.",
        });
        setLoading(false);
      });
  };

  const handleRazorpayPayment = () => {
    if (!validateForm()) return;

    const options = {
      key: "rzp_live_SoUf7yLu0yStIh",
      amount: totalAmount * 100,
      currency: "INR",
      name: "Flawskin",
      description: "Payment for selected services",
      handler: function (response) {
        submitToGoogleScript("Online Payment", response.razorpay_payment_id);
      },
      prefill: {
        name: formData.name,
        email: formData.email,
        contact: formData.number,
      },
      theme: { color: "#0d6efd" },
    };

    const razor = new window.Razorpay(options);
    razor.open();
  };

  return (
    <div className="bg-light min-vh-100 pb-5">
      <Navbar />
      <div className="container mt-4">
        <div className="row g-4">
          {/* Left Column: Details Form */}
          <div className="col-lg-7">
            <div className="card border-0 shadow-sm p-4 rounded-4 bg-white">
              <h4 className="fw-bold mb-4 text-dark">Appointment Details</h4>
              <form onSubmit={(e) => e.preventDefault()}>
                {/* Personal Information Group */}
                <div className="row g-3 mb-4">
                  <div className="col-12">
                    <label className="form-label small fw-semibold text-secondary">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg border-light-subtle bg-light-subtle custom-focus"
                      name="name"
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-semibold text-secondary">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      className="form-control form-control-lg border-light-subtle bg-light-subtle custom-focus"
                      name="number"
                      placeholder="10-digit mobile number"
                      value={formData.number}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-semibold text-secondary">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control form-control-lg border-light-subtle bg-light-subtle custom-focus"
                      name="email"
                      placeholder="name@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <hr className="text-black-50 my-4" />

                {/* Scheduling Group */}
                {/* Scheduling Group */}
                <h5 className="fw-bold mb-1 text-dark">Schedule Session</h5>
                <p className="text-muted small mb-3">
                  Select your preferred date and time for the service.
                </p>

                {/* Dynamic Booked Slots Indicator */}
                {formData.date && (
                  <div
                    className={`mb-3 p-3 rounded-3 border ${isDateFullyBooked ? "bg-danger-subtle border-danger-subtle" : "bg-light border-light-subtle"}`}
                  >
                    <div className="d-flex align-items-center mb-2">
                      <span
                        className={`p-1.5 rounded-circle d-inline-flex me-2 ${isDateFullyBooked ? "bg-danger" : "bg-warning-subtle"}`}
                      >
                        <span
                          className={`p-1 rounded-circle ${isDateFullyBooked ? "bg-white" : "bg-warning"}`}
                        ></span>
                      </span>
                      <span
                        className={`small fw-semibold ${isDateFullyBooked ? "text-danger" : "text-secondary"}`}
                      >
                        {isDateFullyBooked
                          ? "🚨 This date is completely full!"
                          : `Unavailable Slots for ${new Date(formData.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}:`}
                      </span>
                    </div>

                    <div className="d-flex flex-wrap gap-2">
                      {isDateFullyBooked ? (
                        <span className="fw-medium small text-danger">
                          Sorry, no slots are available. Please choose another
                          date below.
                        </span>
                      ) : slotsForSelectedDate.length > 0 ? (
                        slotsForSelectedDate.map((slot, index) => (
                          <span
                            key={index}
                            className="badge bg-danger-subtle text-danger border border-danger-subtle rounded-3 py-2 px-3 fw-medium small"
                          >
                            {slot.startTime} - {slot.endTime} (Booked)
                          </span>
                        ))
                      ) : (
                        <span className="text-success small fw-medium">
                          ✨ All slots are currently available for this date!
                        </span>
                      )}
                    </div>
                  </div>
                )}

                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <label className="form-label small fw-semibold text-secondary">
                      Preferred Date
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-lg border-light-subtle bg-light-subtle custom-focus"
                      name="date"
                      min={todayStr}
                      value={formData.date}
                      onChange={(e) => {
                        handleDateChange(e);
                        setFormData((prev) => ({
                          ...prev,
                          date: e.target.value,
                          time: "",
                        }));
                      }}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-semibold text-secondary">
                      Preferred Time
                    </label>
                    <input
                      type="time"
                      className={`form-control form-control-lg border-light-subtle custom-focus ${isDateFullyBooked || !formData.date ? "bg-secondary-subtle text-muted" : "bg-light-subtle"}`}
                      name="time"
                      value={formData.time}
                      onChange={handleTimeChange}
                      disabled={!formData.date || isDateFullyBooked}
                      required
                    />
                    {isDateFullyBooked && (
                      <div className="text-danger small mt-1 fw-medium">
                        * Please select a different date above to unlock time
                        selection.
                      </div>
                    )}
                  </div>
                </div>

                <hr className="text-black-50 my-4" />

                {/* Address Group */}
                <div className="mb-2">
                  <h5 className="fw-bold mb-2 text-dark">Service Location</h5>
                  <p className="text-muted small mb-3">
                    We provide premium services at your doorstep. Please share
                    your exact location setup details.
                  </p>
                  <textarea
                    className="form-control border-light-subtle bg-light-subtle custom-focus"
                    name="message"
                    placeholder="Complete address with landmarks..."
                    rows="3"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
              </form>
            </div>
          </div>

          {/* Right Column: Order Summary & Sticky CTA Stack */}
          <div className="col-lg-5">
            <div
              className="card border-0 shadow-sm p-4 rounded-4 bg-white position-sticky"
              style={{ top: "2rem" }}
            >
              <h4 className="fw-bold mb-4 text-dark">Order Summary</h4>

              {/* Selected Services Display */}
              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2">
                  Selected Services ({cart.length})
                </label>
                <div className="d-flex flex-wrap gap-2 max-h-32 overflow-y-auto p-1">
                  {cart.map((item) => (
                    <Badge
                      key={item.id}
                      bg="light"
                      className="text-dark border d-flex align-items-center py-2 px-3 rounded-pill fw-medium"
                    >
                      {item.name}
                      <Button
                        variant="link"
                        size="sm"
                        className="text-danger ms-2 p-0 text-decoration-none fw-bold"
                        style={{ lineHeight: 1, fontSize: "1.1rem" }}
                        onClick={() => removeFromCart(item.id)}
                      >
                        &times;
                      </Button>
                    </Badge>
                  ))}
                </div>
              </div>

              <hr className="text-black-50" />

              {/* Price Breakdown */}
              <div className="d-flex justify-content-between align-items-center my-3">
                <span className="text-secondary fw-medium">
                  Total Amount Due
                </span>
                <span className="fs-3 fw-bold text-dark">
                  ₹{formatCurrency(totalAmount)}
                </span>
              </div>

              {/* Terms Checkbox */}
              <div className="form-check mb-4 align-items-center d-flex">
                <input
                  type="checkbox"
                  id="terms"
                  className="form-check-input me-2 custom-checkbox"
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
                <label
                  htmlFor="terms"
                  className="form-check-label small text-muted"
                >
                  I accept the{" "}
                  <a
                    href="/privacy"
                    className="text-primary text-decoration-none fw-medium"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms and Conditions
                  </a>
                </label>
              </div>

              {/* Payment Buttons Container */}
              <div className="d-grid gap-3">
                <button
                  type="button"
                  className="btn btn-dark py-3 px-4 rounded-3 d-flex align-items-center justify-content-center transition-all"
                  disabled={!isChecked || loading}
                  onClick={() => submitToGoogleScript("Cash on Service")}
                >
                  <img
                    src="assets/assets/img/cod.png"
                    alt="Cash on Delivery"
                    className="me-2"
                    style={{
                      width: "32px",
                      height: "auto",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                  <span className="fw-semibold">Pay Cash On Service</span>
                </button>

                <button
                  type="button"
                  className="btn btn-primary py-3 px-4 rounded-3 d-flex align-items-center justify-content-center transition-all shadow-sm"
                  disabled={!isChecked}
                  onClick={handleRazorpayPayment}
                >
                  <img
                    src="assets/assets/img/UPI-White.png"
                    alt="UPI Payment"
                    className="me-2"
                    style={{
                      width: "32px",
                      height: "auto",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                  <span className="fw-semibold">
                    Pay Securely via UPI / Card
                  </span>
                </button>
                <div className="text-center mt-4">

                  <div className="d-flex justify-content-center align-items-center gap-4 payment-methods">
                    <img
                      src="https://cdn.simpleicons.org/visa/808080"
                      alt="Visa"
                      height="26"
                    />

                    <img
                      src="https://cdn.simpleicons.org/mastercard/808080"
                      alt="Mastercard"
                      height="26"
                    />

                    <img
                      src="https://cdn.simpleicons.org/googlepay/808080"
                      alt="Google Pay"
                      height="26"
                    />
                    <img
                      src="https://cdn.simpleicons.org/razorpay/808080"
                      alt="Google Pay"
                      height="26"
                    />

                    <img
                      src="https://cdn.simpleicons.org/applepay/808080"
                      alt="Apple Pay"
                      height="26"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modern Wave Spinner Overlay */}
      {loading && (
        <div
          className="loading-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(15, 23, 42, 0.6)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
          }}
        >
          <div className="d-flex align-items-end" style={{ height: "60px" }}>
            {[0, 1, 2, 3].map((i) => (
              <div
                key={i}
                style={{
                  width: "12px",
                  height: "15px",
                  margin: "0 4px",
                  backgroundColor: "#ffffff",
                  borderRadius: "6px",
                  animation: "loading-wave-animation 1s ease-in-out infinite",
                  animationDelay: `${i * 0.15}s`,
                }}
              ></div>
            ))}
          </div>
          <style>{`
            @keyframes loading-wave-animation {
              0%, 100% { height: 15px; }
              50% { height: 50px; }
            }
            .custom-focus:focus {
              background-color: #fff !important;
              border-color: #86b7fe !important;
              box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15) !important;
            }
            .custom-checkbox:checked {
              background-color: #0d6efd;
              border-color: #0d6efd;
            }
            .transition-all {
              transition: all 0.2s ease-in-out;
            }
            .transition-all:hover:not(:disabled) {
              transform: translateY(-1px);
            }
            .max-h-32 { max-height: 8rem; }
          `}</style>
        </div>
      )}
    </div>
  );
};

export default CheckoutPage;
